module.exports = __webpack_public_path__ + "img/icon_map_63_on_010.a3c50684.png";